import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { path } from 'ramda';
import { ButtonProps } from 'antd/lib/button/button';

interface CustomButtonProps {
  backgroundColor?: string;
  color?: string;
  height?: string;
  width?: string;
  margin?: string;
  borderRadius?: string;
  fontSize?: string;
  children?: React.ReactNode;
}

const ButtonWrapper = styled.div<CustomButtonProps>`
  button {
    background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : props.theme.colors.primary.main)};
    color: ${(props) => (props.color ? props.color : props.theme.colors.common.white)};
    height: ${(props) => (props.height ? props.height : '40px')};
    width: ${(props) => (props.width ? props.width : '170px')};
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    border-radius: ${(props) => (props.borderRadius ? props.borderRadius : '0px')};
    font-size: ${(props) => (props.fontSize ? props.fontSize : path(['theme', 'font', 'size', 'body']))};
    font-weight: bold;
    &:hover {
      background-color: ${(props) =>
        props.backgroundColor ? props.backgroundColor : props.theme.colors.primary.main} !important;
      color: ${(props) => (props.color ? props.color : 'white')} !important;
      border-color: transparent !important;
    }
    &:active {
      background-color: ${(props) =>
        props.backgroundColor ? props.backgroundColor : props.theme.colors.primary.main} !important;
      color: ${(props) => (props.color ? props.color : 'white')} !important;
      border-color: transparent !important;
    }
    &:focus {
      background-color: ${(props) =>
        props.backgroundColor ? props.backgroundColor : props.theme.colors.primary.main} !important;
      color: ${(props) => (props.color ? props.color : 'white')} !important;
      border-color: transparent !important;
    }
    border-color: transparent;
  }
  width: ${(props) => (props.width ? props.width : '170px')};
`;

const StyledButton = ({
  backgroundColor,
  color,
  height,
  width,
  margin,
  borderRadius,
  fontSize,
  children,
  ...buttonAntDesignProps
}: CustomButtonProps & ButtonProps) => {
  return (
    <ButtonWrapper
      backgroundColor={backgroundColor}
      color={color}
      height={height}
      width={width}
      margin={margin}
      borderRadius={borderRadius}
      fontSize={fontSize}
    >
      <Button {...buttonAntDesignProps}>{children}</Button>
    </ButtonWrapper>
  );
};

export default StyledButton;
